/*Global Constants and Functions*/
var tempModalData = null;
var qrCodeObject = null;
var blockedDatesObjectOne = [];
var blockedDatesObjectTwo = [];
var blockedDatesObjectThree = [];
var quickQRCodeString = null;
var currentDeathDate = null;
var currentDeathTime = null;
var lastSelectedToDate = null;
var i18n = {
    de: {
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        dayOfWeek: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
    }
};
var timeBoxSpinner = null;

function setSelectValue(select, value) {
    if (!select) {
        return;
    }
    if (select.indexOf('#') < 0) {
        select = '#' + select;
    }
    $(select).val(value);
}

function removeUnfittingHTMLElems(fieldArray, tagName) {
    fieldArray.forEach((x) => {
        if (x.tagName.toLowerCase() !== tagName)
            fieldArray = fieldArray.filter((y) => y !== x);
    });

    return fieldArray;
}

function makeToast(message) {
    Materialize.toast(message, 3000, 'rounded');
}

function setNewQRCodeBaseString(baseString) {
    quickQRCodeString = baseString;
}

function imageFieldToBaseObject(fieldID, wantedHeight) {
    if (!fieldID) {
        return null;
    }
    var imageField = document.getElementById(fieldID);
    if (!imageField) {
        return null;
    }
    var ratioWidth = imageField.width;
    var ratioHeight = imageField.height;

    if (wantedHeight) {
        var heightRatio = (wantedHeight / ratioHeight) * 100;
        ratioWidth = (ratioWidth / 100) * heightRatio;
        ratioHeight = wantedHeight;
    }

    var globalCanvas = document.getElementById('globalCanvas');
    if (!globalCanvas) {
        return null;
    }
    globalCanvas.width = (ratioWidth * 2);
    globalCanvas.height = (ratioHeight * 2);

    var globalCanvasContext = globalCanvas.getContext('2d');
    if (!globalCanvasContext) {
        return null;
    }
    globalCanvasContext.drawImage(imageField, 0, 0, (ratioWidth * 2), (ratioHeight * 2));

    return {
        width: ratioWidth,
        height: ratioHeight,
        payload: globalCanvas.toDataURL()
    };
}

function cleanInput(inputString, shouldURLEncode) {
    //TODO: Write real cleaning
    if (shouldURLEncode) {
        encodeURIComponent(inputString);
    }
    return inputString;
}

function unwrapResponse(responseBody) {
    return responseBody.data;
}

function openCameraWithID(inputID) {
    if (!inputID) {
        return;
    }
    if (inputID.indexOf('#') < 0) {
        inputID = '#' + inputID;
    }
    $(inputID).click();
}

function openContractAddModal() {
    $('#openNewContractButton').click();
}

function openModalWithID(modalID) {
    if (!modalID) {
        return;
    }
    if (modalID.indexOf('#') < 0) {
        modalID = '#' + modalID;
    }
    $(modalID).openModal();
    scrollModalToTop();

    if (modalID === "#searchModal") {
        const input = $("#globalSearch");
        input.val(" ");
        input.focus();
    } else if (modalID === "#contactModal") {
        initSelect();
        const input = $("#msg");
        input.val(" ");
        input.focus();
    }

    updateMaterialTextFields();
}

function updateMaterialTextFields() {
    Materialize.updateTextFields();
}

function closeModalWithID(modalID) {
    if (!modalID) {
        return;
    }
    if (modalID.indexOf('#') < 0) {
        modalID = '#' + modalID;
    }
    $(modalID).closeModal();
}

function initSideNav() {
    $(document).ready(function () {
        $("#slideMenuButton").sideNav({
            menuWidth: 450,
            closeOnClick: true
        });
    });
}

function initCollapsible() {
    setTimeout(function () {
        $('.collapsible').collapsible({ accordion: true });
    }, 1);
}

function initTabs() {
    setTimeout(function () {
        $('ul.tabs').tabs();
    }, 1);
}

function initSelect() {
    setTimeout(function () {
        $('select').material_select();
    }, 1);
}

function initMaterialBox() {
    setTimeout(function () {
        $('.materialboxed').materialbox();
    }, 1);
}

function initToolTip() {
    setTimeout(function () {
        $('.tooltipped').tooltip('remove');
        $('.tooltipped').tooltip({ delay: 10 });
    }, 1);
}

function initDropDown() {
    setTimeout(function () {
        $('.dropdown-button').dropdown();
    }, 1);
}

function initPrintContractDropDown() {
    setTimeout(function () {
        $('.dropdown-button-print').dropdown({ constrain_width: false });
    }, 1);
}

function initSendContractDropDown() {
    setTimeout(function () {
        $('.dropdown-button-send').dropdown({
            constrain_width: false,
            gutter: -89
        });
    }, 1);
}

function initFormsDropDown() {
    setTimeout(function () {
        $('.dropdown-button-forms').dropdown({
            constrain_width: false,
            hover: false,
            gutter: 0,
            belowOrigin: true,
            alignment: 'left'
        });
    }, 1);
}

function initNavMenuMoreDropDown() {
    setTimeout(function () {
        $('.dropdown-button-nav-menu-more').dropdown({
            constrain_width: false,
            hover: false,
            belowOrigin: true,
            alignment: 'right'
        });
    }, 1);
}

function initQRCodeInFieldWithID(fieldID, initialText) {
    if (!qrCodeObject) {
        qrCodeObject = new QRCode(fieldID, {
            text: initialText,
            width: 100,
            height: 100,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        });
    }
}

function initLeanModal() {
    $('.modal-trigger').leanModal({
        dismissible: false,
        ready: function () {
            scrollModalToTop();
        }
    });
}

function genereateQRCodeInFieldWithId(elementID, qrString) {
    new QRCode(document.getElementById(elementID), qrString);
}

function clearQRCode() {
    if (!qrCodeObject) { return false; }
    qrCodeObject.clear();
    return true;
}

function makeQRCode(qrCodeString) {
    if (!qrCodeObject || !qrCodeString) { return false; }
    qrCodeObject.makeCode(qrCodeString);
    return true;
}

function convenientSaveModalDataToDrafts() {
    /*if (!tempModalData || !tempModalData.burialData || !tempModalData.burialData.qrstring) {return;}
    var currentDrafts = null;
    var isUpdate = false;

    if (localStorage.hasOwnProperty('drafts')) {
        currentDrafts = JSON.parse(localStorage.drafts);
    }

    if (!currentDrafts) {
        currentDrafts = [];
    }

    for (var draftIndex in currentDrafts) {
        if (currentDrafts[draftIndex].burialData.qrstring == tempModalData.burialData.qrstring) {
            isUpdate = true;
            currentDrafts[draftIndex] = tempModalData;
            break;
        }
    }

    if (!isUpdate && tempModalData.burialData.qrstring.length > 10) {
        currentDrafts.push(tempModalData);
    }

    localStorage.drafts = JSON.stringify(currentDrafts);
    tempModalData = null;*/
}

function isValidStr(str) {
    return str && typeof str === 'string' && str.trim() !== '';
}

function addLeadingZero(value) {
    value = '' + value;
    if (value.length < 2) {
        return '0' + value;
    }
    return value;
}

function getValueFromFieldWithID(fieldID) {
    if (!fieldID) {
        return;
    }
    if (fieldID.indexOf('.') < 0) {
        fieldID = '.' + fieldID;
    }
    return $(fieldID).val();
}

function gotoBurialsTab() {
    setTimeout(function () {
        $('#burialsTabID').click();
    }, 1);
}

function gotoInfosTab() {
    setTimeout(function () {
        $('#infoTabID').click();
    }, 1);
}

function setReadonlyOnInputsToState(readonlyState, isForced) {
    if (!readonlyState) {
        $('input, textarea').prop('readonly', false);
        $('select').prop('disabled', false);
        return;
    }
    $('input, textarea').each(function () {
        var thisClass = $(this).attr('class');
        if (thisClass?.indexOf('select') < 0 && thisClass?.indexOf('ng-') < 0) {
            var thisValue = $(this).val();
            if (thisValue || isForced) {
                thisClass = thisClass.replace(/\s/g, '.');
                $('.' + thisClass).prop('readonly', true);
                $('.' + thisClass).prop('disabled', true);
            }
        }
    });
    $('select').each(function () {
        if (this.id != 'inputLocation') {
            var thisClass = $(this).attr('class');
            var thisValue = $(this).val();
            if ((thisValue && thisValue != 0) || isForced) {
                thisClass = thisClass.replace(/\s/g, '.');
                $('.' + thisClass).prop('readonly', true);
                $('.' + thisClass).prop('disabled', true);
            }
        }
    });
}

function scrollModalToTop() {
    setTimeout(function () {
        $('.modal').animate({ scrollTop: 0 }, 1);
    }, 1);
}

function sendContactRequest() {
    var postBody = {
        burialnumber: cleanInput(fieldValue, false),
        rolle_admin: cleanInput(rolle_admin, false)
    };

    sendAsyncRequestOfType('contact', postBody, function (responseBody) {
        responseBody = unwrapResponse(responseBody);
        $scope.isLoading = false;
        if (responseBody.success && responseBody.hasOwnProperty('payload') && responseBody.payload && responseBody.payload.hasOwnProperty('dataArray') && responseBody.payload.dataArray) {
            $scope.fileCache = responseBody.payload.dataArray;
        } else {
            makeToast('Abfrage fehlgeschlagen');
        }
    });
}

function openContactModal() {
    openModalWithID('contactModal');
}

function closeMobileDrawer() {
    $('.sidenav-close').sideNav('hide');
}

function logoutUser() {
    for (var key in localStorage) {
        delete localStorage[key];
    }

    window.location = '/login';
    closeModalWithID('logoutModal');
}

function scrollToElement(element) {
    var ele = document.getElementById(element);
    window.scrollTo(ele.offsetLeft, ele.offsetTop);
}

function handleTempModalData(tempModalData) {
    if (!tempModalData) { return tempModalData; }
    this.tempModalData = tempModalData;
    if (tempModalData == 'null') { this.tempModalData = null; }
}

function handleCurrentDeathDate(currentDeathDate) {
    if (!currentDeathDate) { return currentDeathDate; }
    this.currentDeathDate = currentDeathDate;
    if (currentDeathDate == 'null') { this.currentDeathDate = null; }
}

function handleCurrentDeathTime(currentDeathTime) {
    if (!currentDeathTime) { return currentDeathTime; }
    this.currentDeathTime = currentDeathTime;
    if (currentDeathTime == 'null') { this.currentDeathTime = null; }
}

function createPDF(orientation, measurement, size) {
    return new jsPDF(orientation, measurement, size);
}

function initBurialsApplicationValues() {
    initSelect();
    initToolTip();
    $('.inputBirthDate,.inputFilterEntry,.inputFilterBurial,.inputFilterStart,.inputFilterEnd').on('keyup', function (event) {
        if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {
            return;
        }
        var value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            newValue += value[i];
            if (i < 5 && (i + 1) % 2 == 0) {
                newValue += '.';
            }
        }
        var newValueArray = newValue.split('.');
        for (var newValueArrayIndex in newValueArray) {
            if (newValueArrayIndex == 0 && newValueArray[0] > 31) {
                newValueArray[0] = 31;
            } else if (newValueArrayIndex == 1 && newValueArray[1] > 12) {
                newValueArray[1] = 12;
            } else if (newValueArrayIndex == 2 && newValueArray[2] > 3000) {
                newValueArray[2] = 3000;
            }
        }
        $(this).val(newValueArray.join('.'));
    });
    $('.inputDeathDate').on('keyup', function (event) {
        if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {
            return;
        }
        var value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            newValue += value[i];
            if (i < 5 && (i + 1) % 2 == 0) {
                newValue += '.';
            }
        }
        var newValueArray = newValue.split('.');
        for (var newValueArrayIndex in newValueArray) {
            if (newValueArrayIndex == 0 && newValueArray[0] > 31) {
                newValueArray[0] = 31;
            } else if (newValueArrayIndex == 1 && newValueArray[1] > 12) {
                newValueArray[1] = 12;
            } else if (newValueArrayIndex == 2 && newValueArray[2] > 3000) {
                newValueArray[2] = 3000;
            }
        }
        $(this).val(newValueArray.join('.'));
    });
    $('.inputDeathTime').on('keyup', function (event) {
        if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {
            return;
        }
        var value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            newValue += value[i];
            if (i < 3 && (i + 1) % 2 == 0) {
                newValue += ':';
            }
        }
        var newValueArray = newValue.split(':');
        for (var newValueArrayIndex in newValueArray) {
            newValueArray[newValueArrayIndex] = '' + newValueArray[newValueArrayIndex];
            if (newValueArrayIndex == 0 && Number(newValueArray[0]) > 24) {
                newValueArray[0] = '24';
            } else if (newValueArrayIndex == 1 && Number(newValueArray[0]) < 24 && Number(newValueArray[1]) > 59) {
                newValueArray[1] = '59';
            } else if (newValueArrayIndex == 1 && Number(newValueArray[0]) == 24 && Number(newValueArray[1]) > 0) {
                newValueArray[1] = '00';
            }
        }
        $(this).val(newValueArray.join(':'));
    });
    $('.inputReturnDate').on('keyup', function (event) {
        if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {
            return;
        }
        var value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            newValue += value[i];
            if (i < 5 && (i + 1) % 2 == 0) {
                newValue += '.';
            }
        }

        var newValueArray = newValue.split('.');
        for (var newValueArrayIndex in newValueArray) {

            if (newValueArrayIndex == 0 && newValueArray[0] > 31) {
                newValueArray[0] = 31;
            } else if (newValueArrayIndex == 1 && newValueArray[1] > 12) {
                newValueArray[1] = 12;
            } else if (newValueArrayIndex == 2 && newValueArray[2] > 3000) {
                newValueArray[2] = 3000;
            }
        }
        $(this).val(newValueArray.join('.'));
    });
    $('.inputReturnTime').on('keyup', function (event) {
        if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) {
            return;
        }
        var value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            newValue += value[i];
            if (i < 3 && (i + 1) % 2 == 0) {
                newValue += ':';
            }
        }
        var newValueArray = newValue.split(':');
        for (var newValueArrayIndex in newValueArray) {
            newValueArray[newValueArrayIndex] = '' + newValueArray[newValueArrayIndex];
            if (newValueArrayIndex == 0 && Number(newValueArray[0]) > 24) {
                newValueArray[0] = '24';
            } else if (newValueArrayIndex == 1 && Number(newValueArray[0]) < 24 && Number(newValueArray[1]) > 59) {
                newValueArray[1] = '59';
            } else if (newValueArrayIndex == 1 && Number(newValueArray[0]) == 24 && Number(newValueArray[1]) > 0) {
                newValueArray[1] = '00';
            }
        }
        $(this).val(newValueArray.join(':'));
    });
    $('.inputBirthDate,.inputDeathDate,.inputReturnDate').on('blur', function (event) {
        var objectClass = $(this).attr('class');
        var value = $(this).val();
        if (!value || value.length < 1) {
            return;
        }
        var valueArray = value.split('.');

        if (valueArray.length > 2 && valueArray[2]) {
            if (valueArray[2].length == 3) {
                if (objectClass && objectClass.indexOf('inputBirthDate') >= 0) {
                    valueArray[2] = '1' + '' + valueArray[2];
                } else {
                    valueArray[2] = '2' + '' + valueArray[2];
                }
            } else if (valueArray[2].length == 2) {
                if (objectClass && objectClass.indexOf('inputBirthDate') >= 0) {
                    valueArray[2] = '19' + '' + valueArray[2];
                } else {
                    valueArray[2] = '20' + '' + valueArray[2];
                }
            } else if (valueArray[2].length == 1) {
                if (objectClass && objectClass.indexOf('inputBirthDate') >= 0) {
                    valueArray[2] = '190' + '' + valueArray[2];
                } else {
                    valueArray[2] = '200' + '' + valueArray[2];
                }
            }
        }

        valueArray = valueArray.reverse();
        value = new Date('' + valueArray.join('/'));
        if (!isNaN(value)) {
            if (objectClass == 'inputBirthDate') {
                var todayValue = new Date();
                if (todayValue < value) {
                    makeToast('Geburtstag darf nicht in der Zukunft liegen');
                    $(".inputBirthDateLabel").addClass("red-text");
                    $(this).val('');
                    return;
                }
            } else if (objectClass == 'inputDeathDate') {
                var todayValue = new Date();
                if (todayValue < value) {
                    makeToast('Todestag darf nicht in der Zukunft liegen');
                    $(".inputDeathDateLabel").addClass("red-text");
                    $(this).val('');
                    return;
                }
            } else if (objectClass == 'inputReturnDate') {
                var todayValue = new Date();
                if (todayValue >= value) {
                    makeToast('Rückführungstermin muss in der Zukunft liegen');
                    $(".inputReturnDateLabel").addClass("red-text");
                    $(this).val('');
                    return;
                }
            }
            $(".inputBirthDateLabel").removeClass("red-text");
            $(".inputDeathDateLabel").removeClass("red-text");
            $(".inputReturnDateLabel").removeClass("red-text");
            $(this).val(addLeadingZero(value.getDate()) + '.' + addLeadingZero(value.getMonth() + 1) + '.' + value.getFullYear());
        } else {
            $(this).val('');
        }
    });
    $('.inputDeathTime,.inputReturnTime').on('blur', function (event) {
        var value = $(this).val();
        if (!value || value.length < 1) {
            return;
        }
        var nowDate = new Date();
        if (value.indexOf(':') === false) {
            $(this).val('');
        }
        var valueArray = value.split(':');
        for (var valueIndex in valueArray) {
            if (valueIndex == 0 && valueArray[valueIndex].length != 2) {
                if (valueArray[valueIndex].length == 1) {
                    valueArray[valueIndex] = addLeadingZero(valueArray[valueIndex]);
                } else {
                    valueArray[valueIndex] = addLeadingZero(nowDate.getHours());
                }
            } else if (valueIndex == 1 && valueArray[valueIndex].length != 2) {
                if (valueArray[valueIndex].length == 1) {
                    valueArray[valueIndex] = addLeadingZero(valueArray[valueIndex]);
                } else {
                    valueArray[valueIndex] = addLeadingZero(nowDate.getMinutes());
                }
            }
        }
        $(this).val(valueArray.join(':'));
    });

    Materialize.updateTextFields();
}

function getAllowedTimesArray(dateTime, type) {
    var baseAllowedTimes = null;
    var newEventLengthModifier = false;
    var selectedType = null;
    var isOhneType = false;

    var dayOfTheWeek = new Date(dateTime);
    dayOfTheWeek = dayOfTheWeek.getDay();

    if (type && type == 'adoption') {
        var fieldArray = document.getElementsByClassName('adoptionType');

        if (fieldArray && fieldArray.length > 0) {
            selectedType = fieldArray[fieldArray.length - 1].value;
            if (selectedType && selectedType == 2) {
                if (dayOfTheWeek && dayOfTheWeek == 1) {
                    baseAllowedTimes = ['06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'];
                } else if (dayOfTheWeek && dayOfTheWeek == 6) {
                    baseAllowedTimes = ['07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00'];
                } else {
                    baseAllowedTimes = ['07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00'];
                }
                isOhneType = true;
            } else {
                baseAllowedTimes = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];
            }
        }
    } else if (type && type == 'anonymous') {
        var fieldArrayOne = document.getElementsByClassName('anonymousBurialTypeOne');
        var fieldArrayTwo = document.getElementsByClassName('anonymousBurialTypeTwo');
        var fieldArrayThree = document.getElementsByClassName('anonymousBurialTypeThree');

        selectedType = 1;
        if ((fieldArrayOne && fieldArrayOne.length > 0 && fieldArrayOne[fieldArrayOne.length - 1].value == 4) ||
            (fieldArrayTwo && fieldArrayTwo.length > 0 && fieldArrayTwo[fieldArrayTwo.length - 1].value == 4) ||
            (fieldArrayThree && fieldArrayThree.length > 0 && fieldArrayThree[fieldArrayThree.length - 1].value == 4)) {
            selectedType = 4;
        }

        if (selectedType && selectedType == 4) {
            baseAllowedTimes = ['08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00'];
            isOhneType = true;
        } else {
            if (dayOfTheWeek == 6)
                baseAllowedTimes = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00'];
            else
                baseAllowedTimes = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];
        }

        //////New Code
        var burialSuiteFieldArray = document.getElementsByClassName('anonymousBurialSite');
        if (burialSuiteFieldArray && burialSuiteFieldArray.length > 0) {
            var burialSuiteSelectedType = burialSuiteFieldArray[burialSuiteFieldArray.length - 1].value;
            if (burialSuiteSelectedType && burialSuiteSelectedType == '8') {
                newEventLengthModifier = true;
            }
        }
        //////*/
    }

    if (baseAllowedTimes && localStorage.hasOwnProperty('blockedDates') && dateTime && type && selectedType) {
        var selectedDate = '' + addLeadingZero(dateTime.getDate()) + '.' + addLeadingZero(dateTime.getMonth() + 1) + '.' + dateTime.getFullYear();
        var tmpBlockedDates = JSON.parse(localStorage.blockedDates);

        var blockedTimes = [];
        for (var dateType in tmpBlockedDates) {
            if (tmpBlockedDates[dateType].hasOwnProperty('mit') && tmpBlockedDates[dateType].mit.hasOwnProperty(selectedDate) && tmpBlockedDates[dateType].mit[selectedDate]) {
                for (var timeIndex in tmpBlockedDates[dateType].mit[selectedDate]) {
                    blockedTimes.push(tmpBlockedDates[dateType].mit[selectedDate][timeIndex]);
                }
            }
            if (!isOhneType) {
                continue;
            }
            if (tmpBlockedDates[dateType].hasOwnProperty('ohne') && tmpBlockedDates[dateType].ohne.hasOwnProperty(selectedDate) && tmpBlockedDates[dateType].ohne[selectedDate]) {
                for (var timeIndex in tmpBlockedDates[dateType].ohne[selectedDate]) {
                    blockedTimes.push(tmpBlockedDates[dateType].ohne[selectedDate][timeIndex]);
                }
            }
        }

        var allowedTimes = [];
        for (var allowedTimeIndex in baseAllowedTimes) {
            var allowedTime = baseAllowedTimes[allowedTimeIndex].split(':');
            allowedTime = addLeadingZero('' + allowedTime[0]) + '.' + addLeadingZero('' + allowedTime[1]);

            var isAllowedTime = true;
            for (var blockedTimeIndex in blockedTimes) {
                var blockedTimeFrom = blockedTimes[blockedTimeIndex].from;
                blockedTimeFrom = addLeadingZero('' + blockedTimeFrom[0]) + '.' + addLeadingZero('' + blockedTimeFrom[1]);
                var blockedTimeTo = blockedTimes[blockedTimeIndex].to;
                blockedTimeTo = addLeadingZero('' + blockedTimeTo[0]) + '.' + addLeadingZero('' + blockedTimeTo[1]);

                if (Number(allowedTime) >= Number(blockedTimeFrom) && Number(allowedTime) < Number(blockedTimeTo)) {
                    isAllowedTime = false;
                    break;
                }
            }

            if (isAllowedTime) {
                allowedTimes.push(baseAllowedTimes[allowedTimeIndex]);
            }
        }

        //////
        if (newEventLengthModifier && allowedTimes && allowedTimes.length > 0) {
            var tmpModifierTimes = [];
            for (var modifierIndex in allowedTimes) {
                if (!allowedTimes[Number(modifierIndex) + Number(1)]) {
                    continue;
                }
                var modifierStartTime = Number(allowedTimes[Number(modifierIndex)].split(':')[0]);
                var modifierAfterTime = Number(allowedTimes[Number(modifierIndex) + Number(1)].split(':')[0]);

                var afterTimeDifference = Number(Number(modifierAfterTime) - Number(modifierStartTime));

                if (afterTimeDifference != 1) {
                    continue;
                }

                tmpModifierTimes.push(allowedTimes[Number(modifierIndex)]);
            }
            allowedTimes = tmpModifierTimes;
        }
        //////
        baseAllowedTimes = allowedTimes;
    } else {
        baseAllowedTimes = false;
    }

    return baseAllowedTimes;
}

function toggleLoadingSpinner(isShown) {
    if (!timeBoxSpinner && isShown) {
        $('.xdsoft_time_box').after('<div class="time_box_spinner"><br><br><br><br>\n' +
            '<div class="preloader-wrapper small active">\n' +
            '<div class="spinner-layer spinner-green-only">\n' +
            '<div class="circle-clipper left">\n' +
            '<div class="circle"></div></div><div class="gap-patch">\n' +
            '<div class="circle"></div></div><div class="circle-clipper right">\n' +
            '<div class="circle"></div></div></div></div></div>');
        timeBoxSpinner = $('.time_box_spinner');
    }

    if (!isShown) {
        $('.time_box_spinner').remove();
        timeBoxSpinner = null;
    }
}

function triggerChangeEventForElementWithId(elementId) {
    if (!elementId) { return; }
    document.getElementById(elementId).dispatchEvent(new Event('change'));
}

function initBurialDates(requestAllowedTimesUpdateCallback) {
    $.datetimepicker.setLocale('de');
    $('.driveServiceDateTimeWishFrom').datetimepicker({
        i18n: i18n,
        weeks: true,
        validateOnBlur: true,
        minDate: 0,
        format: 'd.m.Y H:i',
        allowTimes: ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
            '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00',
            '16:30', '17:00', '17:30', '18:00'],
        onGenerate: function () {
            $(this).find('.xdsoft_date.xdsoft_day_of_week0').addClass('xdsoft_disabled');
            $(this).find('.xdsoft_date.xdsoft_day_of_week6').addClass('xdsoft_disabled');
        },
        onChangeDateTime: function (dp, $input) {
            var selectedValue = $input.val();
            if (!selectedValue || selectedValue.length < 1) {
                return;
            }
            lastSelectedToDate = selectedValue;
            
            triggerChangeEventForElementWithId('driveServiceDateTimeWishFrom');
        }
    });
    $('.driveServiceDateTimeWishTo').datetimepicker({
        i18n: i18n,
        weeks: true,
        validateOnBlur: true,
        minDate: 0,
        format: 'd.m.Y H:i',
        allowTimes: ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'],
        onGenerate: function () {
            $(this).find('.xdsoft_date.xdsoft_day_of_week0').addClass('xdsoft_disabled');
            $(this).find('.xdsoft_date.xdsoft_day_of_week6').addClass('xdsoft_disabled');
        },
        onShow: function () {
            if (!lastSelectedToDate) { return; }

            var lastSelectedToArray = lastSelectedToDate.split(' ');
            if (lastSelectedToArray.length < 2) { return; }

            var selectedToDate = lastSelectedToArray[0].split('.');
            var selectedToTime = lastSelectedToArray[1].replace(':', '');
            if (selectedToDate.length < 3) { return; }

            // Berechne die Mindestzeit (AB-Uhrzeit + 3 Stunden)
            var fromTimeParts = lastSelectedToArray[1].split(':');
            var fromHours = parseInt(fromTimeParts[0], 10);
            var fromMinutes = parseInt(fromTimeParts[1], 10);
            var minHours = fromHours + 3;
            var minMinutes = fromMinutes;
            // Wenn minHours >= 24, dann ist es der nächste Tag - setze auf 24:00 um alle Zeiten zu deaktivieren
            if (minHours >= 24) {
                minHours = 24;
                minMinutes = 0;
            }
            // Konvertiere zu einem vergleichbaren Zeitstring (HHMM)
            // Für halbstündige Zeiten: wenn Minuten 30 sind, dann ist die nächste verfügbare Zeit die nächste halbe Stunde
            var minTimeCompare;
            if (minMinutes == 0) {
                minTimeCompare = (minHours < 10 ? '0' : '') + minHours + '00';
            } else {
                // Wenn Minuten > 0, dann ist die nächste verfügbare Zeit die nächste halbe Stunde
                minTimeCompare = (minHours < 10 ? '0' : '') + minHours + '30';
            }

            var newAllowedTimes = ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'];
            var tmpAllowedTimes = [];
            for (var allowedTimeIndex in newAllowedTimes) {
                var compareTime = newAllowedTimes[allowedTimeIndex].replace(':', '');
                // Nur Zeiten anzeigen, die mindestens 3 Stunden nach der AB-Uhrzeit liegen
                if (Number(compareTime) < Number(minTimeCompare)) { continue; }
                tmpAllowedTimes.push(newAllowedTimes[allowedTimeIndex]);
            }

            newAllowedTimes = tmpAllowedTimes;

            this.setOptions({
                startDate: selectedToDate[2] + '/' + selectedToDate[1] + '/' + selectedToDate[0],
                minDate: selectedToDate[2] + '/' + selectedToDate[1] + '/' + selectedToDate[0],
                allowTimes: newAllowedTimes
            });
        },
        onChangeDateTime: function (dp, $input) {
            var selectedValue = $input.val();
            if (selectedValue && selectedValue.length > 0) {
                // Prüfe ob VON-Feld leer ist
                var fromField = $('.driveServiceDateTimeWishFrom');
                if (fromField.length > 0 && (!fromField.val() || fromField.val().length === 0)) {
                    // Setze VON auf den gleichen Wert wie BIS
                    fromField.val(selectedValue);
                    triggerChangeEventForElementWithId('driveServiceDateTimeWishFrom');
                }
            }
            triggerChangeEventForElementWithId('driveServiceDateTimeWishTo');
        }
    });
    $('.adoptionDateTimeWish').datetimepicker({
        i18n: i18n,
        validateOnBlur: true,
        format: 'd.m.Y H:i',
        minDate: 0,
        formatDate: 'd.m.Y',
        onGenerate: function () {
            $(this).find('.xdsoft_date.xdsoft_day_of_week0').addClass('xdsoft_disabled');
        },
        onShow: function (dateTime) {
            /*var currentAllowedTimes = getAllowedTimesArray(dateTime, 'adoption');

            this.setOptions({
                allowTimes: currentAllowedTimes
            });

            if (currentAllowedTimes.length < 1) {
                setPickerTimeBoxVisible(false);
            } else {
                setPickerTimeBoxVisible(true);
            }*/

            toggleLoadingSpinner(true);
            setPickerTimeBoxVisible(false);
            requestAllowedTimesUpdateCallback(this, dateTime, 'adoption');
        },
        onSelectDate: function (dateTime) {
            var currentAllowedTimes = getAllowedTimesArray(dateTime, 'adoption');

            this.setOptions({
                allowTimes: currentAllowedTimes
            });

            if (currentAllowedTimes.length < 1) {
                setPickerTimeBoxVisible(false);
            } else {
                setPickerTimeBoxVisible(true);
            }
        },
        onChangeDateTime: function (dp, $input) {
            triggerChangeEventForElementWithId('adoptionDateTimeWish');
        }
    });
    $('.anonymousBurialSiteDateTimeWish').datetimepicker({
        i18n: i18n,
        validateOnBlur: true,
        format: 'd.m.Y H:i',
        formatDate: 'd.m.Y',
        minDate: 0,
        onGenerate: function () {
            $(this).find('.xdsoft_date.xdsoft_day_of_week0').addClass('xdsoft_disabled');
        },
        onShow: function (dateTime) {
            /*var currentAllowedTimes = getAllowedTimesArray(dateTime, 'anonymous');

            this.setOptions({
                allowTimes: currentAllowedTimes
            });

            if (currentAllowedTimes.length < 1) {
                setPickerTimeBoxVisible(false);
            } else {
                setPickerTimeBoxVisible(true);
            }*/

            toggleLoadingSpinner(true);
            setPickerTimeBoxVisible(false);
            requestAllowedTimesUpdateCallback(this, dateTime, 'anonymous');
        },
        onSelectDate: function (dateTime) {
            var currentAllowedTimes = getAllowedTimesArray(dateTime, 'anonymous');

            this.setOptions({
                allowTimes: currentAllowedTimes
            });

            if (currentAllowedTimes.length < 1) {
                setPickerTimeBoxVisible(false);
            } else {
                setPickerTimeBoxVisible(true);
            }
        },
        onChangeDateTime: function (dp, $input) {
            triggerChangeEventForElementWithId('anonymousBurialSiteDateTimeWish');
        }
    });
    $('.datepicker,.timepicker,.datetimepicker').click(function () {
        $(this).datetimepicker('show');
    });
    $('.driveServiceDateTimeWishFrom,.driveServiceDateTimeWishTo').on('keyup', function (event) {
        if (event.keyCode == 8) {
            $(this).val('');
        }
    });
}

function setPickerTimeBoxVisible(isVisible) {
    if (isVisible) {
        $('.xdsoft_time_box,.xdsoft_prev,.xdsoft_next').show();
    } else {
        $('.xdsoft_time_box,.xdsoft_prev,.xdsoft_next').hide();
    }
}

function initPartnered() {
    initCollapsible();
    setTimeout(() => {
        const targetEle = $('.collapsible-header.active')[0];
        const pos = targetEle.style.position;
        const top = targetEle.style.top;
        targetEle.style.position = 'relative';
        targetEle.style.top = '-60px';
        targetEle.scrollIntoView({ behavior: 'smooth', block: 'start' });
        targetEle.style.top = top;
        targetEle.style.position = pos;
    }, 100);
}